import Glide from '@glidejs/glide';

// Glide sliders settings //
const Glides = () => {
    if (document.getElementById('about-us-glide')) {
        const aboutUs = new Glide('#about-us-glide', {
            type: 'carousel',
            perView: 3,
            gap: 20,
            peek: 0,
            breakpoints: {
                992: {
                    perView: 2,
                    peek: 80
                },

                512: {
                    perView: 1,
                    peek: 40,
                }
            }
        });

        aboutUs.mount();
    }

    if (document.getElementById('procedures-glide')) {
        const proceduresGlide = new Glide('#procedures-glide', {
            type: 'carousel',
            perView: 1,
            gap: 45,
            peek: 30,
            dragDistance: false,
            breakpoints: {
                512: {
                    gap: 25,
                    peek: 45,
                }
            }
        });

        proceduresGlide.mount();
    };

    if (document.getElementById('procedure-glide')) {
        const procedureGlide = new Glide('#procedure-glide', {
            type: 'carousel',
            perView: 3,
            gap: 20,
            peek: 0,
            breakpoints: {
                992: {
                    perView: 2,
                    peek: 80
                },

                512: {
                    perView: 1,
                    peek: 40,
                }
            }
        });

        procedureGlide.mount();
    }

};

export default Glides;